import React from "react";
import { Link } from "react-router-dom";
import logoWhite from "../../assets/images/logo-white.svg";
import "../../assets/styles/notfound.css";

export default function NotFound() {
  return (
    <div className="nf-page">
      <div className="nf-glow nf-glow-a" />
      <div className="nf-glow nf-glow-b" />

      <Link to="/" className="nf-logo-link">
        <img src={logoWhite} alt="IMERGEY" className="nf-logo" />
      </Link>

      <div className="nf-content">
        <div className="nf-code">404</div>
        <h1>This page took a wrong turn.</h1>
        <p>The page you're looking for doesn't exist, moved, or never did. Let's get you back on track.</p>

        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-ghost">← Back to home</Link>
          <Link to="/book-demo" className="nf-btn nf-btn-primary">Lost? Let's book a demo instead →</Link>
        </div>
      </div>
    </div>
  );
}
